<template>
  <!-- pagination -->
  <div
    class="
      d-flex
      justify-content-center
      fs-4
      align-items-center
      py-12
      text-dark
    "
  >
    <nav aria-label="Page navigation example">
      <div class="d-flex align-items-center">
        <ul class="pagination m-0">
          <li class="fs-4 bg-transparent d-flex align-items-center">
            <a
              class="p-3 bg-transparent border-0"
              href="#"
              aria-label="Previous"
            >
              <span class="material-icons" aria-hidden="true"
                >chevron_left</span
              >
            </a>
          </li>
          <li
            class="fs-4"
            v-for="page in emitTotalPage.TotalPage"
            :key="page"
          >
            <button
              class="border-0 rounded-pill bg-transparent"
              style="width:48px; height:48px;"
              @click.prevent="updatePage(page)"
            >
              {{ page }}
            </button>
          </li>
          <li class="fs-4 rounded-pill">
            <a class="bg-transparent" href="#" aria-label="Next">
              <span class="material-icons" aria-hidden="true"
                >chevron_right</span
              >
            </a>
          </li>
        </ul>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  // 接收父層傳送來的 Data
  props: {
    parentTotalPage: {
      type: Object,
      // 重點 : 避免傳進來是空的陣列或是物件
      default: () => {}
    }
  },
  data () {
    return {
      emitTotalPage: {}
    }
  },
  // 每次傳送的資料都不同，需監聽內容有無變動
  watch: {
    // 父層傳進來的值
    parentTotalPage () {
      this.emitTotalPage = this.parentTotalPage
      console.log(this.emitTotalPage)
    }
  },
  created () {
    this.emitTotalPage = this.parentTotalPage
    console.log(this.emitTotalPage)
  },
  methods: {
    updatePage (page) {
      this.$emit('emit-pages', page)
    }
  }
}
</script>
